export const ManageRequestPath = {
  MANAGE_REQUESTS: 'manage-requests',
};
